import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
// import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'

import NProgress from 'vue-nprogress'
import Snotify, { SnotifyPosition } from 'vue-snotify'

import '@/design/snotify-style.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from "vue-select";

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'
// import Swal from "sweetalert2";
import SimpleBar from "simplebar-vue";
// import VueAnalytics from 'vue-analytics';
// import SockJS from "sockjs-client";
// import Stomp from "webstomp-client";

import App from './App.vue'

import { initFirebaseBackend } from './authUtils'

const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    icon: false,
    timeout: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    maxOnScreen: 2,
    maxAtPosition: 2,
    preventDuplicates: true,
    //titleMaxLength: 110,
    bodyMaxLength: 1110,
  }
};

Vue.component("v-select", vSelect);



Vue.use(SimpleBar)
Vue.component('simplebar', SimpleBar)





initFirebaseBackend();

Vue.use(VueRouter)
Vue.use(vco)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})

Vue.use(VueAxios, axios)
Vue.use(Snotify, options)





 
// const nprogress = new NProgress({ parent: '.nprogress-container' })
//const nprogress = new NProgress()

const options2 = {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: false, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, options2)




//Vue.component('apexchart', VueApexCharts)

// Event Bus for sharing events between components
export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),

  mounted: function(){


  }

}).$mount('#app')
